export * from './berichte.component';
export * from './berichte.component.module';